import React from "react"
import { Col, Form, Row } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { ProductCustomAttributesImageSelectComponentProps } from "../../../../../../../common/types"
import IntlProps from "../../../../../../../state/helpers/IntlProps"
import {
    ProductCustomDefinitionImageMetadata
} from "../../../../../../../state/product-custom-attributes/CustomAttributeDefinition"
import {
    CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION,
    CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION,
    CUSTOM_ATTRIBUTE_TYPE_SELECT,
    CUSTOM_ATTRIBUTES_MESSAGES,
    generateFilteredMetadata,
    NO_AVAILABLE_IMAGE_IMAGE_PATH
} from "../../../../../../../utils"
import "./ProductCustomAttributesComponent.scss"

const ProductCustomAttributesImageSelectComponent = (props: ProductCustomAttributesImageSelectComponentProps & IntlProps) => {
    const filteredMetadata = generateFilteredMetadata(props.isEditable, props.metadata, props.selectValue)
    let actionType

    const handleCustomAttributeChange = (metadata, checked) => {
        if (!props.isEditable) {
            return
        }
        if (checked) {
            actionType = CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION
        } else {
            actionType = CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION
        }
        return props.onHandleCustomAttributeChange(
            {
                allowMoreThanOneChoice: props.allowMoreThanOneChoice,
                attributeType: CUSTOM_ATTRIBUTE_TYPE_SELECT.value,
                value: metadata.id || "",
                itemId: props.itemId,
                customAttributeDefinitionId: props.customAttributeDefinitionId,
                actionType
            }
        )
    }

    if (props.isPdf) {
        const selectedMetadata = (filteredMetadata || []).filter(metadata => props.selectValue.includes(metadata.id))
        return (
            <div className="mb-1">
                <div>
                    <label className="col-sm-2 col-form-label">{props.label}{props.isRequired &&
                        <span className="text-danger">*</span>}:
                    </label>

                    {(selectedMetadata || []).map((metadata: ProductCustomDefinitionImageMetadata, index: number) => {
                        const imageUrl = metadata.images?.[0]?.attributes?.publicUrl
                        return (
                            <span key={index}>
                                <span className="col-sm-8">
                                    <label className={"pr-2"}>
                                        {metadata.label || ""}
                                    </label>

                                    {imageUrl &&
                                        <img
                                            src={metadata.images?.[0]?.attributes?.publicUrl}
                                            className="img-thumbnail select-attribute-image"
                                            alt="Responsive image"
                                        />
                                    }
                                </span>

                            </span>
                        )
                    })}
                </div>
                {!props.hideDivider && <hr className="hr"/>}
            </div>
        )
    }

    const containsImages = filteredMetadata?.some(metadata => {
        return (metadata.images as [])?.length > 0
    })

    return <div
    >
        <Row className="mb-3">
            <Col>
                <label className="col-sm-9 col-form-label">{props.label}{props.isRequired &&
                    <span className="text-danger">*</span>}
                </label>
            </Col>
            {props.allowMoreThanOneChoice && props.isEditable &&
                <Col>
                    {props.intl.formatMessage(
                        CUSTOM_ATTRIBUTES_MESSAGES["customAttributeProposal.more_than_one_choice_helper_text"]
                    )}
                </Col>}

        </Row>
        <Row className="mb-3" xs={12}>
            {(filteredMetadata || []).map((metadata: ProductCustomDefinitionImageMetadata, index: number) => {
                return <Col className="mb-3" xs={4} key={index}>
                    <div className="justify-content-center">

                        {containsImages &&
                            <div
                                className="d-flex justify-content-center"
                            >
                                <img
                                    src={metadata.images?.[0]?.attributes?.publicUrl || NO_AVAILABLE_IMAGE_IMAGE_PATH}
                                    className="img-thumbnail select-attribute-image"
                                    alt="Responsive image"
                                />
                            </div>
                        }
                        <div className="d-flex justify-content-center">
                            <label>
                                {metadata.label || ""}
                                <br/>
                                <Form.Check
                                    type="radio"
                                    id="itemStatusMultipleChoice"
                                    disabled={!props.isEditable}
                                    checked={props.selectValue?.includes(metadata.id || "")}
                                    onClick={() => handleCustomAttributeChange(metadata, props.selectValue?.includes(metadata.id || ""))}
                                />
                            </label>
                        </div>
                    </div>
                </Col>
            })}
        </Row>
        {!props.hideDivider && <hr className="hr"/>}
    </div>
}

export default injectIntl(ProductCustomAttributesImageSelectComponent)


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/product-custom-attribute/components/productCustomAttributesImageSelect/ProductCustomAttributesImageSelectComponent.tsx